/* ---------------------------------------------------------------------------
   BENAMI — כפתור עצירה לסרטונים שמתנגנים לבד (#40, 29/09/2026)

   WCAG 2.2.2 (רמה A, חלק מת"י 5568): תוכן נע שמתחיל לבד ונמשך יותר מ-5 שניות
   צריך דרך לעצור אותו. באתר עשרה סרטוני רקע בלולאה, ותשעה מהם לא נעצרו בשום דרך.

   ⛔ סרטון עם controls — לא נוגעים: יש לו כבר עצירה.
   ⛔ סרטון שנעצר נשאר עצור: התמה מפעילה סרטונים מחדש כשהם נכנסים למסך, ולכן
      מאזין play עוצר שוב כל עוד הגולשת בחרה לעצור.
   ⛔ מי שביקשה במערכת "פחות תנועה" (prefers-reduced-motion) — מתחילים עצורים.
   ⛔ ה-CSS מוזרק מכאן ומכוון ל-.benami-vp בלבד. שום כלל גלובלי.
--------------------------------------------------------------------------- */
(function () {
  if (window.__benamiVideoPause) {
    return;
  }
  window.__benamiVideoPause = true;

  var he = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('he') === 0;
  var LABEL = he ? { pause: 'עצירת הסרטון', play: 'הפעלת הסרטון' } : { pause: 'Pause video', play: 'Play video' };
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"/></svg>';

  var style = document.createElement('style');
  style.id = 'benami-vp-style';
  /* מרכז התחתית ולא פינה: בפינות המסך יושבים כבר כפתורי הנגישות, הוואטסאפ והתגמולים.
     ⛔ 56px ולא 16: ההירו בדף הבית בגובה המסך ונדחף למטה ע"י פס ההודעות — ב-16 הכפתור
     נולד מתחת לקצה המסך (נמדד 29/09: 890 מתוך 900). */
  /* ⛔ !important במיקום ובגודל: ב-content-over-media התמה מחילה על כל ילד שאינו מדיה position,
     place-self ורוחב משלה, בסלקטור חזק משלנו — ובלי זה הכפתור נחת בצד, באמצע הגובה (נמדד 29/09). */
  var B = 'button.benami-vp[data-benami-vp-for]';
  style.textContent =
    B + '{position:absolute!important;inset:auto auto 56px 50%!important;transform:translateX(-50%)!important;' +
    'margin:0!important;z-index:3!important;width:40px!important;height:40px!important;max-width:none!important;' +
    'padding:0;border:0;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;' +
    'color:#fff;background:rgba(17,17,17,.55);}' +
    B + ':hover{background:rgba(17,17,17,.75);}' +
    B + ':focus-visible{outline:2px solid #fff;outline-offset:2px;box-shadow:0 0 0 4px rgba(17,17,17,.85);}' +
    B + ' svg{width:16px;height:16px;fill:currentColor;}';
  document.head.appendChild(style);

  function attach(video) {
    if (video.dataset.benamiVp || video.controls || !video.loop) {
      return;
    }
    video.dataset.benamiVp = '1';

    /* ⛔ בסקשן שבו טקסט יושב מעל הסרטון (content-over-media), הכפתור נכנס לקונטיינר עצמו ולא
       ל-video-media: video-media הוא שכבה נפרדת, ושכבת הטקסט מעליו בלעה את הלחיצה (נמדד 29/09
       בהירו של דף הבית — elementFromPoint החזיר את שכבת הטקסט ולא את הכפתור). */
    var host = video.closest('.content-over-media') || video.closest('video-media') || video.parentElement;
    if (!host) {
      return;
    }
    var id = String(++attach.count);
    video.dataset.benamiVpId = id;
    if (window.getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'benami-vp';
    button.dataset.benamiVpFor = id;

    function sync() {
      var stopped = video.dataset.userPaused === '1';
      button.innerHTML = stopped ? ICON_PLAY : ICON_PAUSE;
      button.setAttribute('aria-label', stopped ? LABEL.play : LABEL.pause);
      button.setAttribute('title', stopped ? LABEL.play : LABEL.pause);
    }

    button.addEventListener('click', function (event) {
      /* הכפתור יושב לפעמים בתוך קישור או מעל שכבת תוכן — הלחיצה שלו בלבד. */
      event.preventDefault();
      event.stopPropagation();
      if (video.dataset.userPaused === '1') {
        video.dataset.userPaused = '';
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {});
        }
      } else {
        video.dataset.userPaused = '1';
        video.pause();
      }
      sync();
    });

    video.addEventListener('play', function () {
      if (video.dataset.userPaused === '1') {
        video.pause();
      }
    });

    if (REDUCE) {
      video.dataset.userPaused = '1';
      video.pause();
    }

    sync();
    host.appendChild(button);
  }

  attach.count = 0;

  function scan() {
    document.querySelectorAll('video').forEach(attach);
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) {
      return;
    }
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
